var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M2 4v14h14v2H2c-.526-.013-1.028-.228-1.4-.6-.372-.372-.587-.874-.6-1.4V4h2zm16.1-4c.261.002.52.057.76.16.24.103.458.252.64.44.188.182.337.4.44.64.103.24.158.499.16.76v12c-.013.526-.228 1.028-.6 1.4-.372.372-.874.587-1.4.6h-12c-.526-.013-1.028-.228-1.4-.6-.372-.372-.587-.874-.6-1.4V2c.002-.261.057-.52.16-.76.103-.24.252-.458.44-.64.182-.188.4-.337.64-.44.24-.103.499-.158.76-.16h12zM17 5V3H7v2h10zm0 4V7H7v2h10zm-4 4v-2H7v2h6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDescription);
export default __webpack_public_path__ + "static/media/icon-description.b45dd91b.svg";
export { ForwardRef as ReactComponent };